


















import { Component, Vue } from 'vue-property-decorator';
import BellIcon from '@/assets/header/bell.svg';

@Component({
  components: {
    BellIcon,
  },
})
export default class HeaderNotification extends Vue {
  open = false;
  $refs!: {
    container: HTMLDivElement;
  }

  close(e: Event) {
    if (!this.$refs.container.contains(e.target as Node) && this.open) {
      this.open = false;
      document.removeEventListener('click', this.close);
    }
  }

  openNotification() {
    if (!this.open) {
      this.open = true;
      setTimeout(() => document.addEventListener('click', this.close), 1);
    }
  }
}
